import React from 'react';

const BlankDropZone = ({
  blank,
  blankId,
  selectedValue,
  isDragOver,
  onDragOver,
  onDragLeave,
  onDrop,
  onRemove,
}) => {
  return (
    <div
      className={`fib-drop-zone inline-flex min-w-[140px] h-11 min-h-11 py-2 px-3 border-2 rounded-lg transition-all duration-300 ease-out items-center justify-center relative
        border-dashed border-[rgba(18,118,109,0.3)] bg-[rgba(18,118,109,0.05)]
        dark:border-[rgba(20,184,166,0.3)] dark:bg-[rgba(20,184,166,0.08)]
        max-md:min-w-[100px] max-md:h-10 max-md:min-h-10 max-md:py-1.5 max-md:px-2.5
        ${isDragOver ? 'drag-over !border-[#12766d] !bg-[rgba(18,118,109,0.15)] border-solid scale-105 dark:!border-[var(--accent-teal)] dark:!bg-[rgba(20,184,166,0.15)]' : ''}`}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
    >
      {selectedValue ? (
        <div className="flex items-center gap-1.5 py-1 px-2.5 max-md:py-0.5 max-md:px-2 max-md:text-[13px] bg-gradient-to-br from-[#12766d] to-[#236463] text-white rounded-md text-sm font-semibold">
          <span>{selectedValue}</span>
          <button
            type="button"
            className="inline-flex items-center justify-center border-none bg-transparent text-white cursor-pointer text-lg font-bold leading-none transition-all duration-200 p-0 m-0 ml-2 w-5 h-5 shrink-0 max-md:w-[18px] max-md:h-[18px] max-md:text-base max-md:ml-1.5 hover:opacity-70 hover:scale-110"
            onClick={(e) => {
              e.stopPropagation();
              onRemove();
            }}
          >
            ×
          </button>
        </div>
      ) : (
        <span className="text-[rgba(26,26,46,0.5)] dark:text-[var(--text-tertiary)] text-sm font-medium max-md:text-[13px]">
          Drop answer here
        </span>
      )}
    </div>
  );
};

export default BlankDropZone;

